import { useEffect, useRef } from 'react';
import { mountBuilder } from '../engine/builder/mount.ts';

// Thin React wrapper: routing/lifecycle only. All builder behavior (canvas,
// sections, skip-logic runtime, responses, exports, ...) lives in
// engine/builder, ported verbatim from legacy/EMR Forms.html.
export default function BuilderPage() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    // Matches the legacy query param name exactly: /builder?form=<id>
    const formId = new URLSearchParams(window.location.search).get('form') || '';
    const unmount = mountBuilder(el, formId);
    return unmount;
  }, []);

  return <div className="builder-root" ref={rootRef} />;
}
